import libraryObjectTypes from 'helpers/enums/entityTypes'

export default {
	library_object_type: libraryObjectTypes.NONE,
}
